import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    id: null, // optional Mã app
    application_id: "", // optional Lưu bundle id hoặc application id của ios|android app
    key: "", // optional Key
    value: "", // optional Giá trị
    status: null, // optional Trạng thái active or inactive
    env: "", // optional Môi trường dev, test, product..
    type: "", // optional Loại value
};

// validation form
model.validForm = {
    id: [], // optional Mã app
    application_id: [ValidService.required], // optional Lưu bundle id hoặc application id của ios|android app
    key: [ValidService.required], // optional Key
    value: [], // optional Giá trị
    status: [], // optional Trạng thái active or inactive
    env: [ValidService.required],
    type: []
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        File: {
            limit: 1,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    }
};

model.trangThai = [
    {
        code: "true",
        text: "Ẩn"
    },
    {
        code: "false",
        text: "Hiện"
    }
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: [],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            application_id: "",
            key: "",
            value: "",
            status: null,
            env: ""
        },
        valid: {
            application_id: "",
            key: "",
            value: "",
            status: null,
            env: ""
        },
        operator: {
            application_id: "",
            key: ":regex_i:",
            value: ":regex_i:",
            status: "",
            env: ":regex_i:"
        }
    }
};

model.doiTuong = [
    {
        code: 'Doctor_His,All',
        text: 'Bác sỹ'
    },
    {
        code: 'Doctor_Hos,All',
        text: 'Bác sỹ trạm'
    },
    {
        code: 'Hospital,All',
        text: 'Bệnh viện'
    },
    {
        code: 'Citizen,All',
        text: 'Người dân'
    },
    {
        code: '',
        text: 'Tất cả'
    }
]

export default model;